export default "__VITE_ASSET__9L$cZK2t__"